import resorts from '~/js/sections/root/includes/resort-slides';
import "~/js/sections/root/includes/slider-countdown";
const resortSlides = [];
const resortSliderWrap = document.querySelector('#resortSlider .slide-wrap');
const ratesJSON = beaches_app.page.ratesArray;
let counter = 0;
const $sliderTop = $('#resortSlider .slide-wrap');
const featuredResort = document.getElementById('featuredResort');
const instagramDots = require("~/js/components/global/NavDots");
const playPause = document.getElementById("playPause");

const slickSlider = () => {

  const $statusSliderTop = $('#resortsNavNew .js-slick-slider-top-counter');

  $sliderTop.on('init', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    const dotsWrap = document.querySelector("#resortSlider .slick-dots");
    const dots = Array.from(dotsWrap.querySelectorAll("li"));

    $statusSliderTop.text(`${i}/${slick.slideCount}`);

    const srcs = $sliderTop
      .find(`div[data-slick-index='0']`)
      .find(".slider-item-inner picture source");
    const img = $sliderTop
      .find(`div[data-slick-index='0']`)
      .find(".slider-item-inner picture img");
    srcs.each(function () {
      const imgSrc = $(this).attr("data-srcset");
      $(this).attr("srcset", imgSrc);
    });
    img.attr("src", img.attr("data-src"));

    /*dots.forEach((dot, index) => {
      if (index <= 0) {
        dot.classList.add("large");
        console.log('enter large, index: ', index);
      } else if (index === 1) {
        dot.classList.add("semi");
        console.log('enter semi, index: ', index);
      } else if (index === 2) {
        dot.classList.add("small");
        console.log('enter small, index: ', index);
      } else {
          dot.classList.add("none");
        }
    });*/
    //instagramDots(dotsWrap, $sliderTop);

  });

  $sliderTop.on("reInit afterChange", (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderTop.text(`${i}/${slick.slideCount}`);
  });

  $sliderTop.slick({
    centerMode: true,
    centerPadding: '0',
    cssEase: 'linear',
    fade: false,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    prevArrow: $('#resortsNavNew .js-prev-slide-in-slider-top'),
    nextArrow: $('#resortsNavNew .js-next-slide-in-slider-top')
  });

  $sliderTop.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    featuredResort.setAttribute('href', resorts.resort[nextSlide].link);

    if (nextSlide === -1) {
      return false;
    }
    if (nextSlide <= slick.slideCount - 1) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
    if (nextSlide <= slick.slideCount - 2) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 1}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 1}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
    if (nextSlide <= slick.slideCount - 3) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 2}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 2}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
  });
};

$(playPause).click((event) => {
  if (event.target.classList.contains("pause")) {
    $sliderTop.slick("slickPause");
    $(playPause).removeClass("pause").addClass("play");
  } else {
    $sliderTop.slick("slickPlay");
    $(playPause).removeClass("play").addClass("pause");
  }
});

resorts.resort.forEach((resort, index, array) => {
  const rstCode = resort.rstCode;

  resortSlides.push(`
    <div class='slider-item'>
      <div class="slider-item-inner">
        <div class="resort-slider-titles">
          <h2 class="resort-slider-title">Beaches ${resort.name}</h2>
          <h3 class="resort-slider-subtitle">${resort.city}, ${resort.country}</h3>
        </div>
        <img class="resort-slider-image" src=${resort.img} altText="">
        <div class='floating-box xs-12 lg-11 lg-offset-1 xl-8 xl-offset-4 xxl-6'>
          <p>${resort.caption}</p>
          ${Object.keys(ratesJSON).length === 0 ? '' : typeof(ratesJSON[rstCode][0].averageRate) === 'undefined' ? '' : `<small>Adult Price from <span class='price'>$${ratesJSON[rstCode][0].averageRate}</span><span class=''> PP/PN<span>(USD)</span></span></small><small>Child Price from <span class='price'>$${ratesJSON[rstCode][0].childRate}</span><span class=''> PP/PN<span>(USD)</span></span></small>`}
        </div>
      </div>
    </div>
  `);
  counter++;
  if (counter === array.length) {
    $(resortSliderWrap).html(resortSlides.join(''));
    slickSlider();

    if (window.innerWidth > 767) {
      $sliderTop.slick("slickPlay");
    }
  }
});